<template>
  <form @keyup.enter="save">
    <div>
      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label field-required">Name</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'required|max:255'"
              :class="{'is-danger': errors.has('name') }"
              name="name"
              v-model="body.name"
              class="input"
              type="text"
              placeholder="Enter name"
            />
            <span
              v-show="errors.has('name')"
              class="help is-danger"
            >{{ errors.first('name') }}</span>
          </p>
        </div>
      </div>

      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label field-required">Company</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'required|max:255'"
              :class="{'is-danger': errors.has('company') }"
              name="company"
              v-model="body.company"
              class="input"
              type="text"
              placeholder="Enter company"
            />
            <span
              v-show="errors.has('company')"
              class="help is-danger"
            >{{ errors.first('company') }}</span>
          </p>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label ">Email</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'max:255|email'"
              :class="{'is-danger': errors.has('email') }"
              name="email"
              v-model="body.email"
              class="input"
              type="text"
              placeholder="Enter email"
            />
            <span
              v-show="errors.has('email')"
              class="help is-danger"
            >{{ errors.first('email') }}</span>
          </p>
        </div>
      </div>

      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label">Phone</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'max:255'"
              :class="{'is-danger': errors.has('description') }"
              name="phone"
              v-model="body.phone"
              class="input"
              type="text"
              placeholder="Enter phone"
            />
            <span
              v-show="errors.has('phone')"
              class="help is-danger"
            >{{ errors.first('phone') }}</span>
          </p>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label">Address</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'max:255'"
              :class="{'is-danger': errors.has('description') }"
              name="description"
              v-model="body.address"
              class="input"
              type="text"
              placeholder="Enter address"
            />
            <span
              v-show="errors.has('description')"
              class="help is-danger"
            >{{ errors.first('description') }}</span>
          </p>
        </div>
      </div>

      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label">Postal code</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'max:255'"
              :class="{'is-danger': errors.has('description') }"
              name="postal_code"
              v-model="body.postal_code"
              class="input"
              type="text"
              placeholder="Enter postal code"
            />
            <span
              v-show="errors.has('postal_code')"
              class="help is-danger"
            >{{ errors.first('postal_code') }}</span>
          </p>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label">Fax</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'max:255'"
              :class="{'is-danger': errors.has('description') }"
              name="fax"
              v-model="body.fax"
              class="input"
              type="text"
              placeholder="Enter description"
            />
            <span
              v-show="errors.has('fax')"
              class="help is-danger"
            >{{ errors.first('fax') }}</span>
          </p>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label">Home page</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'max:255'"
              :class="{'is-danger': errors.has('description') }"
              name="homepage"
              v-model="body.homepage"
              class="input"
              type="text"
              placeholder="Enter homepage"
            />
            <span
              v-show="errors.has('homepage')"
              class="help is-danger"
            >{{ errors.first('homepage') }}</span>
          </p>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label">Country</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'max:255'"
              :class="{'is-danger': errors.has('description') }"
              name="country"
              v-model="body.country"
              class="input"
              type="text"
              placeholder="Enter country"
            />
            <span
              v-show="errors.has('country')"
              class="help is-danger"
            >{{ errors.first('country') }}</span>
          </p>
        </div>
      </div>
      <div class="columns form-footer">
        <div class="column is-3"></div>

        <div
          class="column is-9 "
          style="display:flex; justify-content: space-between;"
        >
          <div class="control">

            <save-button
              :loading="isSaving"
              @click="save"
            />
            <a
              @click="cancel"
              class="button is-link"
            >Cancel</a>
          </div>

          <div
            class=""
            v-if="isEditing"
          >
            <a
              @click="deleteSupplier"
              class="button is-link btn-delete"
            >Delete</a>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import mixin from "components/mixin";

export default {
  mixins: [mixin],
  props: {
    data: {
      type: Object,
      default () {
        return {};
      }
    },
    isEditing: Boolean,
    isSaving: Boolean
  },
  data () {
    return {
      body: {
        name: this.data.name ? this.data.name : "",
        company: this.data.company ? this.data.company : "",
        email: this.data.email ? this.data.email : "",
        phone: this.data.phone ? this.data.phone : null,
        address: this.data.address ? this.data.address : null,
        postal_code: this.data.postal_code ? this.data.postal_code : null,
        fax: this.data.fax ? this.data.fax : null,
        homepage: this.data.homepage ? this.data.homepage : null,
        country: this.data.country ? this.data.country : null
      }
    };
  },
  methods: {
    deleteSupplier () {
      this.$emit('deleteSupplier')
    },
    cancel () {
      this.$emit("cancel");
    },
    save () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("save", this.body);
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
